import React from "react";
import styled from "styled-components";
import logo from "../img/logo.png";
import logoserum from "../img/logo-serum.svg";
import logomusee from "../img/logo-musee.png";
import { useStateContext } from "../global-context/useGlobalContext";
const Projects = () => {
  const { language } = useStateContext();
  const cards = [
    {
      logo: logo,
      url: "https://jcesardesign.com",
      name: "J. Cesar Design",
      descriptionFR: "Petite entreprise de web design.",
      DescriptionEN: "Small web design business.",
    },
    {
      logo: logoserum,
      url: "https://leserumelixir.com",
      name: "Le Serum Elixir",
      descriptionFR:
        "Petite entreprise de produits de soins de la peau, biologiques",
      DescriptionEN: "Small company of organic skin care products.",
    },
    {
      logo: logomusee,
      url: "https://www.museedesutton.com",
      name: "Musée des communications et d'histoire de Sutton",
      descriptionFR:
        "Petite organisation à but non-lucratif, qui organise des expositions temporaires thématiques.",
      DescriptionEN:
        "Small non-profit organization, that organizes temporary thematic expositions.",
    },
  ];

  return (
    <ProjectsWrapper>
      {cards.map((card) => {
        return (
          <ProjectsCard key={card.name}>
            <ImageStyle>
              <a
                href={card.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={card.logo}
                  alt=""
                />
              </a>
            </ImageStyle>
            <CardText>
              <a
                href={card.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <h1>{card.name}</h1>
                {card.url}
                <p>{language ? card.descriptionFR : card.DescriptionEN}</p>
              </a>
            </CardText>
          </ProjectsCard>
        );
      })}
    </ProjectsWrapper>
  );
};

export default Projects;

const ProjectsWrapper = styled.section`
  height: fit-content;
  width: 100vw;
  background: none;
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: space-between;
  color: white;
  padding-top: 15vh;
  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

const ProjectsCard = styled.div`
  margin: 10vh auto;
  background: transparent;
  border: solid 1px #f9cc0b;
  border-radius: 1rem;
  height: 50vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  height: fit-content;
  width: 25rem;
`;

const ImageStyle = styled.div`
  margin: 1rem;
  margin-top: 2rem;
  img {
    max-height: 20rem;
    border-radius: 1rem;
    max-width: 20rem;
    border: 1px solid #f9cc0b;
  }
`;

const CardText = styled.div`
  border: solid 1px #f9cc0b;
  border-radius: 1rem;
  padding: 0.5rem;
  margin: 1rem;
  margin-bottom: 2rem;
  width: fit-content;
  text-align: center;
  @media (max-width: 850px) {
    margin: 1rem 1.5rem;
  }
  h1 {
    padding: 3vh 0vw;
  }
  p {
    padding: 1.5vh 0vw;
  }
`;
